import { render, staticRenderFns } from "./IconSortAscendingSolid.vue?vue&type=template&id=0671201e"
import script from "./IconSortAscendingSolid.vue?vue&type=script&lang=js"
export * from "./IconSortAscendingSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports